/**
 * Trunnion AI - Execution Compare Page
 * /executions/compare - Side-by-side comparison of two execution results.
 */

import { ExecutionCompare } from '@/components/execution/ExecutionCompare';

export default function ExecutionComparePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Execution Comparison</h1>
        <p className="text-sm text-trunnion-slate-400 mt-1">
          Compare two executions side-by-side to analyze differences in outputs, timing, and results.
        </p>
      </div>
      <ExecutionCompare />
    </div>
  );
}
